import { create } from 'zustand';

import type { ActiveFormState } from './types';

/**
 * Bridge store carrying the active object form's prefillable state up to the AI
 * chat side panel, which is mounted outside every `RiskSmartFormProvider` (see
 * `ActiveFormState`). Mirrors `useObjectToolbarFormStore`: single-slot, set by
 * the active form's `ActiveFormPublisher` and cleared on unmount.
 */
export interface ActiveFormStore {
  /** State of the active object form, or `null` when none is mounted. */
  formState: ActiveFormState | null;
  /** Publish (or replace) the active form's prefill state. */
  setFormState: (state: ActiveFormState) => void;
  /** Clear the slot — called by the publishing form on unmount. */
  clearFormState: () => void;
}

export const useActiveFormStore = create<ActiveFormStore>((set) => ({
  formState: null,
  setFormState: (state) => set({ formState: state }),
  clearFormState: () => set({ formState: null }),
}));
